export default __webpack_public_path__ + "static/media/scan.6c7370da.svg";